import { apiGet, apiSend, USE_MOCK_API } from './httpClient'
import { getTrip, updateTrip } from './trips.mock'
import { addPoint } from './points.mock'
import { ApiError } from './store'
import { tripDayCount } from '../lib/dates'
export interface CruiseSearchItem { sailing_id:string;line:string;ship:string;depart_date:string;return_date:string;nights:number;
  source_url:string;price_per_person:number|null;priced_on:string|null }
export interface CruiseDay { day:number;port:string;date:string;arrival_time?:string|null;departure_time?:string|null }
export interface CruiseProgram { sailing_id:string;line:string;ship:string;depart_date:string;return_date:string;nights:number;
  source_url:string;days:CruiseDay[];issues:string[];valid:boolean }
export async function searchCruises(query:string):Promise<CruiseSearchItem[]> {
  if (USE_MOCK_API) return []
  return apiGet(`/cruises/search?q=${encodeURIComponent(query)}`)
}
export async function getCruiseProgram(id:string):Promise<CruiseProgram> {
  if (USE_MOCK_API) throw new Error('Live cruise search requires the backend')
  return apiGet(`/cruises/${encodeURIComponent(id)}/program`)
}
export async function importCruise(tripId:string,program:CruiseProgram,expectedUpdatedAt:string,returnBufferMinutes:number):Promise<void> {
  if (!USE_MOCK_API) {
    await apiSend('POST',`/trips/${tripId}/cruise/apply`,{program,expected_updated_at:expectedUpdatedAt,
      return_buffer_minutes:returnBufferMinutes});return
  }
  const trip=await getTrip(tripId)
  if (trip.updated_at!==expectedUpdatedAt) throw new ApiError(409,'Trip changed; review cruise again')
  if (trip.cruise_sailing_id===program.sailing_id) return
  if (trip.cruise_sailing_id) throw new ApiError(409,'Another cruise is attached')
  if (!trip.start_date||!trip.end_date||trip.start_date>program.depart_date||trip.end_date<program.return_date)
    throw new ApiError(400,'Trip dates must contain the cruise')
  for (const day of program.days) await addPoint(tripId,{title:day.port,
    type:day.port.toLowerCase()==='at sea'?'event':'port',day_index:tripDayCount(trip.start_date,day.date)-1,
    date:day.date,time:day.arrival_time ?? null,end_time:day.departure_time ?? null,
    timing:day.arrival_time&&day.departure_time?'window':'day',duration_minutes:0,
    notes:day.arrival_time&&day.departure_time?`Return buffer: ${returnBufferMinutes} min`:'Port hours unconfirmed'})
  await updateTrip(tripId,{cruise_sailing_id:program.sailing_id})
}
